<template>
  <div class="search-container pb-xl-6 pb-lg-6 pb-md-2 pb-sm-2 pb-3">
    <v-row justify="center" class="pt-4 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters>
      <v-col xl="8" lg="9" md="10" sm="11" cols="11">
        <div class="text-left font-weight-bold search-title mt-1 mb-2">
          Consultar orden
        </div>
        <div class="body-2 text-left text-muted font-weight-light">
          <span class="text--primary">
            Aquí podrás revisar tu pedido, donde podrás ver el detalle del pedido, realizar el seguimiento del envío o registrar si tuvo algún inconveniente con su orden, por favor ingrese el código de su pedido y presione enter o de clic en el botón de búsqueda.
          </span>
        </div>
      </v-col>
      <v-col xl="8" lg="9" md="10" sm="12" cols="12">
        <v-row justify="center" class="pt-0" no-gutters>
          <v-col xl="12" lg="12" md="12" sm="11" cols="11">
            <v-row justify="center">
              <v-col cols="12">
                <v-form ref="form" v-model="valid" onSubmit="return false;">
                  <v-row justify="center" class="pt-6" no-gutters>
                    <v-col cols="12">
                      <v-text-field class="mt-n4" v-model="orderCode"
                        label="Código del pedido"
                        hint="Requerido"
                        :rules="[isRequired, minimum(5)]"
                        persistent-hint
                        solo
                        @keyup.native.enter="searchOrder">
                        <template v-slot:append-outer>
                          <v-btn class="search-button" color="blue darken-1" dark :loading="loading" @click="searchOrder">
                            <v-icon dark>
                              mdi-magnify
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isRequired, minimum } from '@/shared/validations'
import navigationMixin from '@/mixins/navigation'
import { getErrorMessage } from '@/shared/errors'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      valid: true,
      orderCode: ''
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading']),
    ...mapState('order', ['_order'])
  },
  methods: {
    isRequired,
    minimum,
    ...mapActions('order', ['getOrderByOrderNumber']),
    async searchOrder () {
      if (!this.$refs.form.validate()) {
        return
      }

      await this.getOrderByOrderNumber(this.orderCode)
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('search_order', this.error) })
        return
      }

      this.goToRouteByName('Order', { id: this._order.order_id })
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .search-container{
    height: 100%;
  }
  .search-title {
    font-size: 24px;
  }
  .text-muted {
    line-height: 1.75em;
  }
  .search-button {
    margin-top: -10px;
    height: 46px !important;
    min-width: 56px !important;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .search-container{
      background-color: #FFFFFF;
    }
    .search-title {
      font-size: 20px;
    }
  }
</style>
